module.exports = __webpack_public_path__ + "img/resources-1440.37e35d03.jpg";